import WithModel from '@Ravnur-Inc/core/WithModel';
import $t from '@Ravnur-Inc/l10n/$t';
import { ErrorObject } from '@vuelidate/core';
import { defineComponent, PropType, computed } from 'vue';

import { Translations } from '../../translations';

const CN = 'password-field';

const PasswordField = defineComponent({
  props: {
    value: { type: String, required: true },
    tkey: { type: String as PropType<keyof Translations>, default: null },
    label: { type: String, default: '' },
    placeholder: { type: String as PropType<keyof Translations>, default: null },
    errors: { type: Array as PropType<ErrorObject[]>, default: [] },
  },
  emits: {
    'update:value': (val: string) => {
      return typeof val === 'string';
    },
  },
  setup(props, ctx) {
    const fieldLabel = props.tkey ? $t('login', props.tkey) : props.label;
    const placeholderText = props.placeholder ? $t('login', props.placeholder) : '';

    const password = computed({
      get: () => props.value,
      set: (password: string) => ctx.emit('update:value', password),
    });

    return () => {
      return (
        <text-field
          class={CN}
          errors={props.errors}
          icon="lock"
          label={fieldLabel}
          maxLength={20}
          placeholder={placeholderText}
          toggleable={true}
          vModel={[password.value, 'value']}
        />
      );
    };
  },
});

export default WithModel(PasswordField, 'value');
